var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNavAccessManagementActive(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "C37139D8-2660-4F4B-943B-EF57E4D800ED") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Company-Portal",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashboard1",
    transform: "translate(-18.000000, -582.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    x: 0,
    y: 0,
    width: 1680,
    height: 1015
  }), /*#__PURE__*/React.createElement("g", {
    id: "Nav-CompanyAdmin"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "none",
    x: 0,
    y: 0,
    width: 245,
    height: 1015
  }), /*#__PURE__*/React.createElement("g", {
    id: "Nav-Off",
    transform: "translate(0.000000, 571.000000)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "AccessManagement",
    transform: "translate(18.000000, 582.000000)",
    fill: "#898381",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.14285714,22 L18.7142857,22 C19.5032639,22 20.1429161,21.3604068 20.1429161,20.5714286 L20.1429161,19.5 C20.1496927,18.1533735 19.5615164,16.8724561 18.5357143,16 C19.0444428,15.1847422 19.1986615,14.1972639 18.96274,13.2657109 C18.7268185,12.3341579 18.1211669,11.5391214 17.2857143,11.0642857 L17.2857143,10.5714286 C17.2857143,9.38796125 16.3263245,8.42857143 15.1428571,8.42857143 L15.1428571,7 C15.1428571,4.23857625 12.9042809,2 10.1428571,2 C7.38143339,2 5.14285714,4.23857625 5.14285714,7 L5.14285714,8.42857143 C3.95938982,8.42857143 3,9.38796125 3,10.5714286 L3,19.8571429 C3,21.0406102 3.95938982,22 5.14285714,22 Z M18.7142857,20.5714286 L12.2857143,20.5714286 L12.2857143,19.5 C12.2882251,18.5596051 12.7098202,17.6692802 13.4357143,17.0714286 C14.6661212,17.9672545 16.3338788,17.9672545 17.5642857,17.0714286 C18.2901798,17.6692802 18.7117749,18.5596051 18.7142857,19.5 L18.7142857,20.5714286 Z M15.5,16.2857143 C14.3165327,16.2857143 13.3571429,15.3263245 13.3571429,14.1428571 C13.3571429,12.9593898 14.3165327,12 15.5,12 C16.6834673,12 17.6428571,12.9593898 17.6428571,14.1428571 C17.6428571,15.3263245 16.6834673,16.2857143 15.5,16.2857143 Z M6.57142857,7 C6.57173554,5.55480842 7.44297584,4.25224588 8.7785667,3.7001808 C10.1141576,3.14811573 11.6508163,3.45537573 12.6714286,4.47857143 C13.3444603,5.14428478 13.720456,6.05337021 13.7142857,7 L13.7142857,8.42857143 L6.57142857,8.42857143 L6.57142857,7 Z M4.42857143,10.5714286 C4.42857143,10.1769395 4.74836804,9.85714286 5.14285714,9.85714286 L15.1428571,9.85714286 C15.5373462,9.85714286 15.8571429,10.1769395 15.8571429,10.5714286 C15.7381994,10.5643865 15.6189435,10.5643865 15.5,10.5714286 C13.5275545,10.5714286 11.9285714,12.1704116 11.9285714,14.1428571 C11.9304284,14.7997545 12.1159906,15.4430368 12.4642857,16 C11.4384836,16.8724561 10.8503073,18.1533735 10.8571429,19.5 L10.8571429,20.5714286 L5.14285714,20.5714286 C4.74836804,20.5714286 4.42857143,20.251632 4.42857143,19.8571429 L4.42857143,10.5714286 Z",
    id: "Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavAccessManagementActive);
export default __webpack_public_path__ + "static/media/NavAccessManagementActive.ad9cf14b641dca18c4e47f6214162f2c.svg";
export { ForwardRef as ReactComponent };